import { Icon } from '@/components/foundations';

export type TimelineEvent = { title: string; time: string; ok: boolean };

/** Linha do tempo da transação (`.timeline`); evento com falha fica vermelho. */
export function Timeline({ events }: { events: TimelineEvent[] }) {
  return (
    <ul className="timeline">
      {events.map((e) => (
        <li key={e.title} className={e.ok ? '' : 'badl'}>
          <span className={`dotc ${e.ok ? '' : 'bad'}`}><Icon name={e.ok ? 'check' : 'x'} /></span>
          <b>{e.title}</b>
          <small>{e.time}</small>
        </li>
      ))}
    </ul>
  );
}
